import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import layoutContext from "../../../context/LayoutContext";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import features from "./../../../assets/features/ride-height.jpg";
import ezfit from "./../../../assets/features/ezifit-rear.jpg";
import schocks from "./../../../assets/features/foam-cell-shock.jpg";
import air from "./../../../assets/features/air-assist.jpg";
import hunter from "./../../../assets/features/hunter.jpg";

const Features = () => {
  const layout = useContext(layoutContext);

  useEffect(() => {
    layout.setSmallNavText("Technical Information");
  }, []);

  return (
    <StyledFeatures>
      <Container>
        <UnderlinedHeader text={"Technical information"} bolder />
        <Section>
          <p>
            Welcome to the technical page. We have created this to assist in
            understanding the suspension on your car, how to works, how to
            repair it and modify it.
          </p>
          <p>
            Pedders are a specialist Suspension & Brake manufacturer, with a
            focus on solutions to problems, be that broken suspension, carrying
            more weight, improving handling, stopping, or resolving known
            weaknesses in certain vehicles.
          </p>
        </Section>
        <Section>
          <Grid>
            <div>
              <Header>Vehicle heights:</Header>
              <p>
                For many vehicles, Pedders offer either raised or lowered
                springs. Traditionally, people refer to a lowering (or a raise)
                of say, 30mm. Whilst useful, this does assume the vehicle is at
                the correct height to begin with. It is certainly quite common
                to buy a set of 30mm lowering coil springs, install them and
                find that the resulting drop was nothing like 30mm. This is, of
                course, because the vehicle had either settled on its springs
                over time, or, had already had springs replaced.
              </p>
              <p>
                To avoid such disappointment, in most cases we will refer to a
                specific installed height. The dimensions are quoted using the
                process shown in the diagram below. So, regardless of the
                vehicle’s current height, the height with the new springs
                installed will be as quoted.
              </p>
              <p>
                Of course, it must be taken into account that other factors can
                affect the final outcome, the primary one being any extra
                weight. Our heights are based on a standard vehicle in the
                unladen condition. If your pick-up has half a ton of “stuff” in
                the back or your car has had an engine swap to a different type,
                then the outcome could very well be different! If this is you,
                please do contact us as we may still have a solution for you.
              </p>
            </div>
            <Flex>
              <StyledImg src={features} alt={"Vehicle heights"} />
              <Centered>
                It will be noted that the quoted height will be, for example,
                “745mm with 16-inch wheels”. This is a reference wheel size.
                That does NOT mean, you can’t fit the suspension to the vehicle
                because it has 17-inch wheels.
              </Centered>
            </Flex>
          </Grid>
        </Section>
        <Section>
          <Grid>
            <Flex>
              <StyledImg
                alt={"Springs and shocks. What do they do?"}
                src={ezfit}
              />
              <Centered>
                803040. Pedders Ezifit Rear Suspension Conversion Kit. For
                Subaru Forester
              </Centered>
            </Flex>
            <div>
              <Header>Springs and shocks. What do they do?</Header>
              <p>
                A common misconception is the function of both the springs and
                shocks. The term shocks, or shock absorbers in invariably
                interchanged with dampers.
              </p>
              <p>
                The springs support the weight of the vehicle, i.e., they hold
                it off the ground.
              </p>
              <p>
                The shocks (dampers) control or damp the movements of the
                vehicle. Shocks do not and cannot * change the height of the
                vehicle.
              </p>
              <p>
                With out the shocks, a vehicle once it encountered a bump would
                continue to bounce long after traversing the bump were it not
                for the shock.
              </p>
              <p>
                Of course, both shocks and springs affect the behaviour of the
                vehicle and are interrelated. This is a complex subject, beyond
                the scope of this page, and covered successfully by many people.
              </p>
              <p>
                *There is of course an exception, and that is the Nivomat self
                levelling system fitted to, amongst others, Subaru Foresters,
                BMW X5’s, Hyundai Sant-fe, & Kia Sorento.
              </p>
              <p>
                On these vehicles, the shock DOES carry some of the vehicles
                weight, but ONLY some. So, a weaker spring than would be
                normally use is fitted, with the shock carrying the remainder.
                This means that when the vehicle is loaded with more weight, the
                shock can respond to this extra weight, ensuring the vehicle
                remains at its unladen height. It achieves this by using the
                motion of the vehicle to “pump” itself back up the original
                height. It is entirely self contained within the shock. There
                are no pipes or wires to the shock. Whilst undoubtedly very
                clever, and very effective when working, they can and do fail,
                the obvious symptoms of which are the rear of the vehicle
                sitting LOWER than it should.
              </p>
              <p>
                Frequently, the lack of any exterior features leads to these
                being replaced with conventional shocks, which does nothing to
                resolve the “sitting low” symptoms.
              </p>
              <p>
                Pedders recognise this, and for many vehicles fitted with
                Nivomat self levelling systems, produce “kits” to convert to
                conventional suspension at a far lower cost than replacing the
                Nivomat shocks with like for like replacements such as the
                Subaru Forester kit below.
              </p>
            </div>
          </Grid>
        </Section>
        <Section>
          <Grid>
            <div>
              <Header>Shocks</Header>
              <p>
                In many instances, Pedders offer more than one shock absorber
                for a given vehicle. Why you may ask?
              </p>
              <p>
                The manufacturer, when designing the vehicle, has to make a
                choice about exactly what it wants the shock to do. If we take a
                pick-up truck such as a Toyota Hilux, it can be used anywhere
                between unladen and fully laden (1000kg load). This is a very
                wide range, and the shock will be designed to work at its
                optimum somewhere in the middle of that range. Elsewhere, it
                must, of necessity be compromised to some extent. Where
                different models exist, for example, an Audi A6, the base model
                will have softer shocks fitted than the RS6 performance version
                of the same car.
              </p>
              <p>
                Pedders are able to offer shocks designed to achieve different
                things to suit how the vehicle is being used. For example, on
                the pick-up described above, we can offer a shock to work at its
                best when fully laden and so the driver will experience a
                better, more stable ride than the standard shock can achieve.
                Likewise, if the vehicle is used unladen all the time, we can
                offer a shock that will make the vehicle more comfortable than
                the original.
              </p>
              <p>
                Likewise, with a car, to improve the handling and performance,
                we can design the shock specifically to achieve this.
              </p>
              <p>
                With these options, Pedders can achieve the outcome that you
                require and with significantly less compromises than the
                standard shocks. We achieve this through clever shock design
                techniques.
              </p>
              <p>
                For further information on shocks and how they work, please take
                a look at the following videos:
              </p>
            </div>
            <Flex>
              <StyledImg src={schocks} alt={"Schocks"} />
              <Centered>
                153226. Pedders Foam Cell shock. Designed for improved ride
                comfort. For Toyota Hilux MK7
              </Centered>
            </Flex>
          </Grid>
          <Grid>
            <iframe
              title={"Feature Video 1"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/d2Qtkvdc7Pc"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Feature Video 2"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/uKjltW4e6X8"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Grid>
        </Section>
        <Section>
          <Header>Springs</Header>
          <p>
            Springs come in different formats, coils, leaf springs, torsion
            bars, air bags. They are all springs. As discussed above, these
            support the weight of the vehicle and control its height.
          </p>
          <p>
            If you want to lower your vehicle, improve its handling, carry more
            load or tow a heavy trailer, it can be desirable to change the
            springs to best suit your intended purpose.
          </p>
          <p>
            As with our shock range, in many cases, Pedders offer more than one
            spring option for a given vehicle, in particular for commercial
            vehicles such as vans and pick-ups.
          </p>
          <p>
            Again, this allows us to provide a solution best suited to the use
            you make of your vehicle. In the case of commercial vehicles in
            particular, it should be considered that a very heavy-duty spring
            that copes well with heavy loads, will produce a less than desirable
            quality of ride comfort when unladen. This is not always the case
            with every heavy-duty spring. However, where this is the case, our
            description will refer to a minimum load in the vehicle to allow an
            acceptable level of ride quality.
          </p>
          <Grid>
            <iframe
              title={"Feature Video 3"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1thpHRHAp8"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Feature Video 4"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/m_ZvsNOUxTg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Grid>
          <p>
            For those interested in carrying heavy loads or towing, and all that
            this entails, as well as how Pedders can assist with this, please
            visit our specific page on this subject.
          </p>
        </Section>
        <Section>
          <Grid>
            <div>
              <Header>Air Bags</Header>
              <p>
                Whilst a “steel” spring of some sort can often be the solution
                to carrying loads, there are also situations where it might not
                be the best solution.
              </p>
              <p>
                Primarily, this where variations in load are large and often,
                and where a heavy-duty spring would not be suitable in the
                unladen state.
              </p>
              <p>
                Pedders Air Assist air bag systems cater for this situation.
                When unladen the bags can be deflated, allowing the vehicles
                suspension to operate in the normal manner, but when heavy loads
                are carried, the air bags are inflated to assist the existing
                suspension in carrying the load.
              </p>
              <p>
                Most of our air bag kits, as supplied, require to be inflated
                with an airline. The same as is used to inflate your tyres.
                However, this may not suit everyone. It is possible to install
                “on board” air so that bag inflation and deflation can be
                carried out wherever you are. This is an additional kit that can
                be purchased.
              </p>
              <p>
                When considering an air bag solution, always remember that its
                function is to assist the vehicles suspension, not replace it.
              </p>
            </div>
            <Flex>
              <StyledImg src={air} alt={"Air Bags"} />
              <Centered>
                494060. Pedders Air Assist kit. For Mitsubishi L200
              </Centered>
            </Flex>
          </Grid>
        </Section>
        <Section>
          <Header>Fitting</Header>
          <p>
            Most our kits are straight forward to fit. Unless otherwise stated,
            replacement with Pedders parts is as described in the relevant
            vehicle workshop manual.
          </p>
          <p>
            However, in some cases, where fitting differs from the original, or
            other changes need to be made, the relevant instructions are
            provided with the kit.
          </p>
          <p>
            We cannot describe here all the possible issues you may encounter
            when fitting suspension. If you are unsure, Pedders recommend
            leaving it to a professional workshop.
          </p>
          <p>
            We do have a number of installers listed on our dealer’s page and
            intend to expand this over time.
          </p>
          <p>
            Each and every kit comes with a handy fitting tips bulletin. This
            covers various topics, but one that does deserve a mention here is
            the fitting of components with bushes.
          </p>
          <p>
            A suspension component with a bush fitted that experience rotational
            movement, i.e. a shock or a lower wishbone/arm, should NOT have its
            securing bolt tightened up until the vehicle is at its normal ride
            height. Tightening this bot whilst the vehicle is off the ground can
            result in early failure.
          </p>
          <p>
            These bushes absorb the rotational movement applied by suspension
            operation by “twisting” the rubber. Rubber can only do so up to a
            point. After which it tears. If the bolt is tightened with the
            vehicle off the ground, when the vehicle is lowered onto the ground,
            even stationary, the bush will already be significantly “twisted”.
            Once the vehicle goes over a bump, further twisting will take place.
          </p>
          <p>
            The bush at ride height should not be under tension so that it can
            move both ways as intended without permanent damage. The likelihood
            of failure is of course dependant on the range of movement its
            subjected to, and this will vary from component to component and
            vehicle to vehicle.
          </p>
          <p>
            It is also worth noting that the same applies when lowering or
            raising a vehicle. Any pivot point bushes, even though otherwise
            untouched, should be loosened off and retightened at ride height.
          </p>
          <p>
            Not doing so, aside from possible earlier failure, will invoke a
            degree of harshness, or in some cases such as the Chrysler 300C,
            prevent a lowered vehicle settling down to its correct ride height.
          </p>
        </Section>
        <Section>
          <Grid>
            <div>
              <Header>Wheel Alignment</Header>
              <p>This subject can make up a whole book!</p>
              <p>However, keeping it simple, consider the following.</p>
              <p>
                If you are changing the height of the vehicle, it is absolutely
                essential that your wheel alignment is checked and corrected. It
                will be wrong after changing the height of the vehicle. Failure
                to do so will impact the way the vehicle drives to some extent,
                but WILL definitely wear out your tyres more quickly.
              </p>
              <p>
                We also strongly recommend checking alignment after fitting
                suspension components that could affect the accuracy of the
                wheel alignment. There are too many variables to explain here
                what can or can’t affect the alignment.
              </p>
              <p>
                For further information on wheel alignment, please take a look
                at the following video:
              </p>
              <iframe
                width="100%"
                height="300"
                src="https://www.youtube.com/embed/LJIolPrh_fE"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div>
              <StyledImg src={hunter} alt={"Wheel Alignment"} />
            </div>
          </Grid>
        </Section>
        <Section>
          <Header>Choosing the right parts</Header>
          <p>
            On our website, on many vehicles, you will find suspension “kits”.
            We have put these together based on our experience of what is
            normally required for any given vehicle.
          </p>
          <p>
            However, in the event, that after looking at our kits, you are not
            sure if they are suitable, or indeed, know its not suitable for your
            needs, we may still be able to help you. On some vehicles, with so
            many options, we cannot list every possibility, so please do get in
            touch, where our experienced team will be happy to assist in
            identifying a solution for you.
          </p>
          <p>
            Please either e-mail on support@pedders.eu or telephone on +48 532
            544 288
          </p>
        </Section>
      </Container>
    </StyledFeatures>
  );
};

export default Features;

const StyledFeatures = styled.section`
  padding-top: 30px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #666666;
  text-align: justify;
  line-height: 1.66;
`;

const StyledImg = styled.img`
  max-width: 100%;
  max-height: 500px;
  height: auto;
`;

const Flex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Centered = styled.p`
  text-align: center;
`;

const Section = styled.div`
  border-bottom: 1px solid #666;
  margin: 20px 0;
  padding: 20px 0;
`;

const Header = styled.h2`
  font-weight: 600;
  margin: 20px 0;
  padding: 5px 0;
  border-bottom: 2px solid #dc3332;
  width: 100%;
  font-size: 24px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
`;
